"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformApiDataToFormData = exports.transformFormDataToApi = void 0;
var InputSelectMoment_1 = require("../components/atoms/InputSelectMoment/InputSelectMoment");
var transformFormDataToApi = function (formData) { return ({
    activity: formData.activity.value,
    sport: formData.sport.value,
    offer: formData.offer.value,
    salesforce: {
        organisation: formData.salesforce_organisation.value,
        contact_person: formData.salesforce_contact_person.value,
        location: formData.salesforce_location.value,
    },
    genders: formData.genders.value,
    rosters: formData.days.value,
    age_bracket: formData.age_bracket.value,
    target_audience: formData.target_audience.value,
    health_impairments: formData.health_impairments.value,
    movement_identities: formData.movement_identities.value,
    membership_type: formData.membership_type.value,
    cost_bracket: parseInt(formData.cost_bracket.value, 10),
    cost_payed_by_time: formData.cost_payed_by_time.value,
    remarks: formData.remarks.value,
    youthfund_applicable: formData.youthfund_applicable.value.includes('youth_fund'),
    online_sharing_information: formData.online_sharing_information.value,
}); };
exports.transformFormDataToApi = transformFormDataToApi;
// This can be used to transform retrieved offer data (e.g. when editing offer) to usable form data, can be used as
// formState starting point in SportsOfferForm.tsx
var transformApiDataToFormData = function (apiData) { return ({
    activity: {
        value: apiData.activity || '',
    },
    sport: {
        value: apiData.sport || '',
    },
    offer: {
        value: apiData.offer || '',
    },
    salesforce_organisation: {
        value: apiData.salesforce && apiData.salesforce.organisation ? apiData.salesforce.organisation : '',
    },
    salesforce_contact_person: {
        value: apiData.salesforce && apiData.salesforce.contact_person ? apiData.salesforce.contact_person : '',
    },
    salesforce_location: {
        value: apiData.salesforce && apiData.salesforce.location ? apiData.salesforce.location : '',
    },
    membership_type: {
        value: apiData.membership_type || '',
    },
    target_audience: {
        value: apiData.target_audience || [''],
    },
    health_impairments: {
        value: apiData.health_impairments || [''],
    },
    movement_identities: {
        value: apiData.movement_identities || [],
    },
    cost_bracket: {
        value: apiData.cost_bracket ? "" + apiData.cost_bracket : '0',
    },
    cost_payed_by_time: {
        value: apiData.cost_payed_by_time || '',
    },
    youthfund_applicable: {
        value: apiData.youthfund_applicable ? ['youth_fund'] : [],
    },
    genders: {
        value: apiData.genders || [],
    },
    remarks: {
        value: apiData.remarks || '',
    },
    online_sharing_information: {
        value: apiData.online_sharing_information || '',
    },
    age_bracket: {
        value: apiData.age_bracket || '',
    },
    days: {
        value: apiData.rosters || [InputSelectMoment_1.emptyDay],
    },
}); };
exports.transformApiDataToFormData = transformApiDataToFormData;
